import Vue from "vue";
import base from "./baseCore";

const buildQueryParams = ({
    search,
    orderBy,
    desc,
    date,
    devices,
    advertising,
    notUsed,
    local,
    establishments,
}) => {
    return {
        filtro: search || "",
        "data.min": date.min,
        "data.max": date.max,
        aparelhos: devices,
        naoUtilizado: notUsed,
        campanhas: advertising,
        ordem: orderBy,
        desc,
        estabelecimentos: establishments,
        locais: local,
    };
};
export default Object.assign(
    {
        apiUrl: "/codigopromocional",

        async list({ pagination, filters }) {
            const url = this.userUrl({
                path: `/${pagination.page}/${pagination.amountPerPage}`,
            });
            const query = buildQueryParams(filters);
            return await Vue.http.get(url, {
                params: query,
            });
        },

        async count({ filters }) {
            const url = this.userUrl({ path: `/paginacao` });
            const query = buildQueryParams(filters);

            return await Vue.http.get(url, {
                params: query,
            });
        },

        async create(data) {
            return await Vue.http.post(this.userUrl(), data);
        },
    },
    base
);
